var _rect, _rect2, _rect3, _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFdStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 93,
    viewBox: "0 0 402 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    width: 15,
    height: 93,
    fill: "#202124"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 33,
    width: 15,
    height: 60,
    fill: "#202124"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 33,
    width: 15,
    height: 60,
    fill: "#202124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205 88.9865C200.587 91.5391 195.464 93 190 93C173.431 93 160 79.5685 160 63C160 46.4315 173.431 33 190 33C195.464 33 200.587 34.4609 205 37.0135V33H220V63V93H205V88.9865ZM205 63C205 71.2843 198.284 78 190 78C181.716 78 175 71.2843 175 63C175 54.7157 181.716 48 190 48C198.284 48 205 54.7157 205 63Z",
    fill: "#202124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0H0V63V93H15V88.9865C19.4126 91.5391 24.5357 93 30 93C46.5685 93 60 79.5685 60 63C60 46.4315 46.5685 33 30 33C24.5357 33 19.4126 34.4609 15 37.0135V0ZM15 63C15 71.2843 21.7157 78 30 78C38.2843 78 45 71.2843 45 63C45 54.7157 38.2843 48 30 48C21.7157 48 15 54.7157 15 63Z",
    fill: "#202124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265 18H250V33H244V45H250V93H265V45H274V33H265V18Z",
    fill: "#202124"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 347.5,
    cy: 9,
    r: 9,
    fill: "#FF7300"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 9,
    r: 9,
    fill: "#FF7300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 93C121.943 93 132.256 86.0214 137.083 75.9197L121.291 72.8753C118.541 76.0164 114.502 78 110 78C103.469 78 97.9127 73.826 95.8535 68H124.146H125H139.585C139.858 66.374 140 64.7036 140 63C140 46.4315 126.569 33 110 33C93.4315 33 80 46.4315 80 63C80 79.5685 93.4315 93 110 93ZM123.27 56C120.755 51.2422 115.756 48 110 48C104.244 48 99.2451 51.2422 96.7301 56H123.27Z",
    fill: "#202124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFdStudio);
export default __webpack_public_path__ + "static/media/Logo_FD_Studio.0f677e64ca9d038bf387b7f93b4d47e7.svg";
export { ForwardRef as ReactComponent };